import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getBans, GetBansParams} from '../api';
import {QUERY__USER_BANS} from '../queryKeys';
import {UserBanListItem} from '../types';

export const useGetBans = <SelectedData = GetListOutput<UserBanListItem>>(
  params?: GetBansParams,
  options?: QueryOptionsForList<UserBanListItem, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__USER_BANS, params],
    queryFn: () => getBans(params),
    ...options,
  });
